'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { LitElement, html } from 'lit-element';
import 'axios';
import Jsona from 'jsona';

var JsonapiResource = /*#__PURE__*/function (_LitElement) {
  _inherits(JsonapiResource, _LitElement);

  var _super = _createSuper(JsonapiResource);

  /*
  ** Constructor
  */
  function JsonapiResource() {
    var _this;

    _classCallCheck(this, JsonapiResource);

    _this = _super.call(this);
    _this.axios = require('axios');
    _this.formatter = new Jsona();
    _this.url = '';
    _this.resource = '';
    _this.response = {};
    return _this;
  }
  /*
  ** Properties
  */


  _createClass(JsonapiResource, [{
    key: "updated",

    /*
    ** Called when the element is updated
    */
    value: function updated(props) {
      if (props.has('response')) {
        // url has changed
        this.data = this.response.data;

        if (!!this.data) {
          this.deserialized = this.formatter.deserialize(this.data);
        }

        var event = new CustomEvent('response-changed', {
          detail: {
            ok: !!this.response.data
          }
        });
        this.dispatchEvent(event);
      }

      if (props.has('url')) {
        this.get();
      }

      if (props.has('deserialized')) {
        this.data = this.formatter.serialize({
          stuff: this.deserialized
        });
      }
    }
    /*
    ** This is the function to call when deserialized data is to be updated
    */

  }, {
    key: "updateData",
    value: function updateData(data) {
      this.deserialized = data;
      this.data = this.formatter.serialize({
        stuff: data
      });
    }
    /*
    ** path getter
    */

  }, {
    key: "delete",

    /*
    ** API DELETE request
    */
    value: function _delete() {
      var that = this;
      this.axios.get(this.path).then(function (response) {
        that.handleResponse(response);
      })["catch"](function (error) {
        that.handleError(error);
      })["finally"](that.afterRequest());
    }
    /*
    ** API GET request
    */

  }, {
    key: "get",
    value: function get() {
      var that = this;
      this.axios.get(this.path).then(function (response) {
        that.handleResponse(response);
      })["catch"](function (error) {
        that.handleError(error);
      })["finally"](that.afterRequest());
    }
    /*
    ** API POST request
    */

  }, {
    key: "post",
    value: function post() {
      var that = this;
      this.axios.post(this.path, this.data).then(function (response) {
        that.handleResponse(response);
      })["catch"](function (error) {
        that.handleError(error);
      })["finally"](that.afterRequest());
    }
    /*
    ** API PATCH request
    */

  }, {
    key: "patch",
    value: function patch() {
      var that = this;
      this.axios.patch(this.path, this.data).then(function (response) {
        that.handleResponse(response);
      })["catch"](function (error) {
        that.handleError(error);
      })["finally"](that.afterRequest());
    }
    /*
    ** API PUT request
    */

  }, {
    key: "put",
    value: function put() {
      this.patch();
    }
    /*
    ** Successful response callback
    */

  }, {
    key: "handleResponse",
    value: function handleResponse(response) {
      this.response = response;
    }
    /*
    ** Error response callback
    */

  }, {
    key: "handleError",
    value: function handleError(error) {
      this.error = error;
    }
    /*
    ** Post response callback
    */

  }, {
    key: "afterRequest",
    value: function afterRequest() {}
  }, {
    key: "path",
    get: function get() {
      return this.url + this.resource;
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        /*
        ** The base URL of the API, no trailing slash
        */
        url: {
          type: String
        },

        /*
        ** The resource to call
        ** eg. /authors/17.json
        */
        resource: {
          type: String
        },

        /*
        ** The response given by the server
        */
        response: {
          type: Object
        },

        /*
        ** The jsonapi-formatted data
        */
        data: {
          type: Object
        },

        /*
        ** The deserialized data
        */
        deserialized: {
          type: Object
        },

        /*
        ** The computed path, composed of url and resource
        */
        path: {
          type: String
        }
      };
    }
  }]);

  return JsonapiResource;
}(LitElement);

customElements.define('jsonapi-resource', JsonapiResource);